<template>
	<v-window v-model="sessionPanel" ref="window">
		<v-window-item @click.stop @keydown.stop>
			<v-card-text class="px-8 py-8">
				<LoginForm
					class="mb-4"
					@logged="handleCompleted"
					@forgotPassword="handleForgotPasswordClick()"
					:showContinueAsGuestTab="showContinueAsGuestTab"
				/>
				<div class="text-center mt-6">
					<v-divider/>
					<div class="mt-n3 mb-3">
						<v-sheet :color="backgroundColor" class="d-inline-block px-3" v-text="$t('loginForm.or')"></v-sheet>
					</div>
				</div>
				<v-list color="transparent" rounded>
					<v-btn
						data-testid="createAccountBtn"
						id="createAccountBtn"
						style="background-color: white"
						color="button"
						outlined
						rounded
						large
						block
						@click="handleRegisterClick"
					>
						<v-icon left>mdi-account-plus-outline mdi-flip-h</v-icon>
						<span v-text="$t('loginForm.createAccount')"></span>
						<v-icon right>mdi-arrow-right</v-icon>
					</v-btn>
				</v-list>
			</v-card-text>
		</v-window-item>
		<v-window-item @keydown.stop @click.stop>
			<v-card-text>
				<v-btn block text @click="sessionPanel = 0">
					<v-icon left>mdi-arrow-left</v-icon>
					<span v-text="$t('loginForm.return')"></span>
				</v-btn>
				<h3 class="font-weight-regular text-center ma-4" v-text="$t('loginForm.createAccount')"></h3>

				<CreateAccountForm :redirect-path="{ name: 'cart_step', params: { step: 'identification' } }" @completed="handleCompleted" />
			</v-card-text>

			<v-card-text>
				<v-divider></v-divider>
			</v-card-text>
			<v-card-title class="text-center pt-0" style="word-break: break-word" v-text="$t('createAccountForm.alreadyHaveAccount')"></v-card-title>
			<v-card-text>
				<v-btn color="button" data-test-selector="create_account_form_already_have_account" outlined dark block @click="sessionPanel = 2">
					<span v-text="$t('btn.login')"></span>
				</v-btn>
			</v-card-text>
		</v-window-item>
		<v-window-item @keydown.stop @click.stop>
			<v-card-text class="px-8 py-8">
				<LoginForm @logged="handleCompleted" @forgotPassword="handleForgotPasswordClick()"  @onReturn="sessionPanel = 1"/>
			</v-card-text>
		</v-window-item>
		<v-window-item @keydown.stop @click.stop>
			<v-card-text>
				<v-btn block text @click="sessionPanel = 0">
					<v-icon left>mdi-arrow-left</v-icon>
					<span v-text="$t('loginForm.return')"></span>
				</v-btn>
				<ForgotPasswordForm @reset="sessionPanel = 2" />
			</v-card-text>
		</v-window-item>
		<v-window-item @keydown.stop @click.stop>
			<v-card-text>
				<v-btn block text @click="sessionPanel = 0">
					<v-icon left>mdi-arrow-left</v-icon>
					<span v-text="$t('loginForm.return')"></span>
				</v-btn>
				<h3 class="font-weight-regular text-center ma-4" v-text="$t('loginForm.completeProfileForm')"></h3>

				<CompleteProfileForm @completed="handleCompleted" />
			</v-card-text>
		</v-window-item>
	</v-window>
</template>

<script>
import CreateAccountForm from '@/components/CreateAccountForm'
import LoginForm from '@/components/LoginForm'
import ForgotPasswordForm from '@/components/ForgotPasswordForm'
import CompleteProfileForm from '@/components/CompleteProfileForm'

export default {
	name: 'KYC',

	components: { CreateAccountForm, LoginForm, CompleteProfileForm, ForgotPasswordForm },

	props: {
		backgroundColor: {
			type: String,
			default: null,
		},
		registerPage: {
			type: Boolean,
			default: false,
		},
		route: {
			type: [Object, String],
			default: null,
		},
		showContinueAsGuestTab: {
			type: Boolean,
			default: false,
		}
	},

	data: () => ({
		sessionPanel: 0,
	}),
	created () {
		switch (this.route) {
			case 'register':
				this.sessionPanel = 1
				break
			case 'login':
				this.sessionPanel = 2
				break
			case 'password.forgot':
				this.sessionPanel = 3
				break
		}
	},

	methods: {
		handleRegisterClick () {
			if (this.registerPage && this.$route.params?.resId) {
				this.$router.push({ name: 'res-register', params: { resId: this.$route.params?.resId} })
			} else if (this.registerPage) {
				this.$router.push({ name: 'register' })
			} else {
				this.sessionPanel = 1
			}
			this.$refs.window.$el.click();
		},
		handleForgotPasswordClick () {
			this.sessionPanel = 3
		},
		handleCompleted (path) {
			if(path) {
				this.$router.push(path);
			}
			window.dispatchEvent(new Event('resize'))
			this.$emit('completed');
			this.$refs.window.$el.click();
		},
	},
}
</script>
